import SkillItem from "./SkillItem";

import { useFetch } from "hooks/useFetch";

export default function Skill() {
	const { data, isError, isLoading } = useFetch("/api/skills");

	return (
		<div className="mt-32 flex flex-col md:flex-row items-start gap-6">
			<div className="w-full md:w-1/2">
				<div className="text-3xl md:text-7xl font-semibold">
					What can I do for your projects
				</div>
				<div className="mt-7 text-gray-500 text-lg md:text-xl">
					there’s my skills for web & mobile development
				</div>
			</div>
			<div className="w-full md:w-1/2">
				{!isError && !isLoading && (
					<>
						{data.map((item, i) => (
							<SkillItem
								key={`${item.id}`}
								icon={item.image}
								title={item.name}
								text={item.description}
							/>
						))}
					</>
				)}

				<div className="text-center text-gray-500">Many More</div>
			</div>
		</div>
	);
}
